import { AgendaEventSummaryModel } from './agendaEventSummary.model';
import { WithSummaryModel } from '../../../../../common/entity/dto/plain/withSummary.model';
import { WorkflowTaskSummaryModel } from '../../../../../workflow/task/api/model/common/workflowTaskSummary.model';
import {OnlineFormSummaryModel} from "../../../../../online-form/form/api/entity/onlineFormSummary.model";

export class AgendaEventModel extends WithSummaryModel<AgendaEventSummaryModel> {
    summary: AgendaEventSummaryModel;
    reminders: WorkflowTaskSummaryModel[] = [];
    onlineForms: OnlineFormSummaryModel[] = [];
}

export enum AgendaContext {
    MEDICAL = 'MEDICAL'
}
